import React from 'react';
import './MLOps.css';

const m_learning = () => {
    return (
        <div className="m_learning__wrap">
            <div className="m_learning container">
                <h3 className="m_learning--title">Understand the MLOps & Practice of Data Engineering in the Real World</h3>
                <p className="m_learning--text inner_pages--text">As data science extends its reach across an enterprise, the need for better management, workflow, production and deployment practices increases. The challenges of deploying and monitoring models in production, managing data science workflows and teams, and understanding ROI are a few of the issues organizations wrestle with.</p>
                <p className="m_learning--text inner_pages--text"><b>Learn best practices for effective data science management.</b></p>
                <p className="m_learning--text inner_pages--text">Sessions in this broad focus area will look at uses cases, best practices, and stories from the field to show how to effectively incorporate data science practice into the wider business process.  This focus area will look beyond data sourcing and modeling towards the many challenges teams need to overcome to effectively apply data science in their organization.</p>
            </div>
        </div>
    );
};

export default m_learning;